module.exports = __webpack_public_path__ + "static/media/about_img1.98e1183b.jpg";